module.exports = __webpack_public_path__ + "static/media/vote-goat.d517aaf2.png";